module.exports = __webpack_public_path__ + "static/img/11.c42ee08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/11.png
// module id = 5TN7
// module chunks = 0